'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = Sponsor;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var _style = require('../style');

var STYLE = _interopRequireWildcard(_style);

var _browserVendorPrefix = require('browser-vendor-prefix');

var _reactRedux = require('react-redux');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function Sponsor(props) {
  var wrapperStyle = _extends({}, style.wrapper, {
    color: STYLE[props.colour]
  }, props.style);

  var image = '/sponsors/' + props.id + '-' + props.colour.toLowerCase() + '.svg';

  return _react2['default'].createElement(
    'div',
    { style: wrapperStyle },
    _react2['default'].createElement(
      'span',
      { style: style.sponsoredBy },
      'presentado por'
    ),
    _react2['default'].createElement('img', { src: image, alt: props.name, style: style.sponsorLogo })
  );
}

;

var style = {
  sponsorLogo: _extends({}, _browserVendorPrefix.alignSelfFlexStart, {
    height: 28,
    marginTop: 5
  }),
  sponsoredBy: {
    fontSize: 12,
    marginTop: 5
  },
  wrapper: {
    marginTop: 20
  }
};
module.exports = exports['default'];